import TooltipWrapper from 'components/TooltipWrapper';
import { FaListCheck } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import { CustomIconProps } from './types';
import { IconWrapper } from './styled';

const IconReview: React.FC<CustomIconProps> = ({ isSelected, onClick, ariaLabel }) => {
  const { t } = useTranslation();
  const tooltipMessage = isSelected ? t('leaves.filterReview') : t('leaves.filterReviewDeselected');
  return (
    <TooltipWrapper
      overlay={tooltipMessage}
      id="customIconTooltip"
    >
      <IconWrapper
        aria-label={ariaLabel}
        isSelected={isSelected}
        onClick={onClick}
      >
        <FaListCheck />
      </IconWrapper>
    </TooltipWrapper>
  );
};

export default IconReview;
